module.exports = __webpack_public_path__ + "img/contrato.dd3ae5f8.png";